package com.rosario.juridico

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import org.jetbrains.skiko.wasm.onWasmReady
import com.rosario.juridico.premium.PremiumManager
import com.rosario.juridico.premium.WebPremiumCache
import com.rosario.juridico.premium.PremiumPurchaseManager
import com.rosario.juridico.premium.MercadoPagoWebProvider
import com.rosario.juridico.repositories.WebUserRepository
import com.rosario.juridico.premium.EntitlementConsistencyState
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        // Verificar y procesar resultado de redirección OAuth si el usuario proviene de Google Sign-In
        MainScope().launch {
            com.rosario.juridico.platform.FirebaseProxy.handleRedirectResult()
        }

        // Inicialización del middleware Premium para Web
        PremiumManager.initialize(
            repository = WebUserRepository(),
            cache = WebPremiumCache()
        )

        // Inicialización del Gestor de Compras para Web
        PremiumPurchaseManager.initialize(
            provider = MercadoPagoWebProvider()
        )

        // Reconnect Refresh: Resurrección automática del flujo al volver la red
        window.addEventListener("online", {
            if (PremiumManager.entitlement.consistency == EntitlementConsistencyState.STALE_CACHE) {
                MainScope().launch {
                    PremiumManager.syncWithServer()
                }
            }
        })

        // Prevenir interferencia del navegador en gestos de trackpad/wheel sobre el canvas
        val composeContainer = document.getElementById("ComposeTarget")
        composeContainer?.addEventListener("wheel", { event ->
            event.preventDefault()
        }, js("({ passive: false })"))

        ComposeViewport(viewportContainerId = "ComposeTarget") {
            JuridicoApp()
        }
    }
}
